const buildFormData = (formData: FormData, data: any, parentKey?: string) => {
  if (data && typeof data === "object" && !(data instanceof Date)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[]` : key);
    });
  } else if (parentKey) {
    const value = data == null ? "" : data;
    formData.append(parentKey, value);
  }
};

export const jsonToFormData = (data: any) => {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};
